module.exports = __webpack_public_path__ + "img/P27.611f3f5a.png";